import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const Solution = () => import('@/views/Solution')
const About = () => import('@/views/About.vue')
const Cooperation = () => import('@/views/Cooperation.vue')
const Synology = () => import('@/views/Synology.vue')
const ITHardware = () => import('@/views/ITHardware.vue')
const ParkConstruction = () => import('@/views/parkConstruction.vue')
// const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
const solution0 = () => import('@/components/solution/solution.vue')
const solutionERP = () => import('@/components/solution/solutionERP.vue')
const solutionMES = () => import('@/components/solution/solutionMES.vue')
const solutionSCM = () => import('@/components/solution/solutionSCM.vue')
const solutionCRM = () => import('@/components/solution/solutionCRM.vue')
const solutionSRM = () => import('@/components/solution/solutionSRM.vue')
const solutionQMS = () => import('@/components/solution/solutionQMS.vue')
const solutionSJZT = () => import('@/components/solution/solutionSJZT.vue')
const solutionDSJFX = () => import('@/components/solution/solutionDSJFX.vue')
const solutionWRZS = () => import('@/components/solution/solutionWRZS.vue')
const solutionPLM = () => import('@/components/solution/solutionPLM.vue')
const solutionWMS = () => import('@/components/solution/solutionWMS.vue')
const solutionAPS = () => import('@/components/solution/solutionAPS.vue')
const Experience = () => import('@/views/Experience.vue')
const routes = [
  {
    path: '',
    component:Home
  },
  {
    path:'/',
    component:Home
  },
  {
    path:'/ProductCenter',
    component:Production,
    // children:[
    //   {
    //     path:'1',
    //     component:ProductionBrain
    //   }
    // ]
  },
  {
    path:'/Solutions',
    component:Solution,
    children:[
      {
        path:'',
        component:solution0
      },{
        path:'erp',
        component:solutionERP
      },{
        path:'mes',
        component:solutionMES
      },{
        path:'scm',
        component:solutionSCM
      },{
        path:'crm',
        component:solutionCRM
      },{
        path:'srm',
        component:solutionSRM
      },{
        path:'qms',
        component:solutionQMS
      },{
        path:'sjzt',
        component:solutionSJZT
      },{
        path:'dsjfx',
        component:solutionDSJFX
      },{
        path:'wrzs',
        component:solutionWRZS
      },{
        path:'plm',
        component:solutionPLM
      },{
        path:'wms',
        component:solutionWMS
      },{
        path:'aps',
        component:solutionAPS
      }
    ]
  },
  {
    path:'/About',
    component:About,
  },
  {
    path:'/BusinessPartner',
    component:Cooperation
  },{
    path:'/Synology',
    component:Synology
  },{
    path:'/Experience',
    component:Experience
  },{
    path:'/ITHardware',
    component:ITHardware
  },{
    path:'/ParkConstruction',
    component:ParkConstruction
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    // 如果目标路由不匹配任何路由规则，则重定向到404页面
    next('/'); // 假设你的404页面路径是'/not-found'
  } else {
    next(); // 确保一定要调用 next()
  }
})
export default router